/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class SponsorshipProductsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Retrieve list of sponsorship products which can be purchased
     */
    public getSponsorshipProducts(__unused?: any): Observable<PagedArray<models.ApiSponsorshipProduct>> {
        const path = '/gifts/sponsorships/products';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiSponsorshipProduct>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get a sponsorship product
     * @param id 
     */
    public getSponsorshipProduct(id?: number, __unused?: any): Observable<models.ApiSponsorshipProduct> {
        const path = '/gifts/sponsorships/products/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiSponsorshipProduct>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
